import { MarketingContentIndexEntry, MarketingFrontMatter } from "../../marketing-content/marketingContentLoader";

/**
 * What every template page receives: the index entry plus the loaded Markdown file, split, and the
 * body's HTML when the build rendered it already (a page served as static HTML; see MarketingMarkdown).
 */
export type MarketingTemplatePageProps = {
  entry: MarketingContentIndexEntry;
  frontMatter: MarketingFrontMatter;
  markdownBody: string;
  renderedBodyHtml: string | null;
};

export function getFrontMatterString(frontMatter: MarketingFrontMatter, key: string): string | null {
  const value = frontMatter[key];
  return typeof value === "string" && value.length > 0 ? value : null;
}
